import { I18n } from 'react-redux-i18n';

export const DEVICE_SUPER_TAG = "20028716136f69533e19";
export const SUPER_TAG='supertag';

export const locationColumn = {
  Header: I18n.t('models.tag.location'),
  defaultHeader: I18n.t('models.tag.location'),
  accessor: item =>
    item.locationName || item.location.name ||
    (item.location.macAddress !== '00:00:00:00:00:00'
      ? item.location.macAddress
      : ''),
  sortField:'locationName',
  allowFilter: true,
  searchable:true,
  allowSort: true
};

export const columns = [
  {
    Header: I18n.t('models.tag.tag'),
    defaultHeader: I18n.t('models.tag.tag'),
    customLabelKey: 'tag',
    accessor: 'name',
    allowFilter: false,
    searchable:true,
    allowSort: true,
    sortField:'name'
  },
  {
    Header: I18n.t('models.tag.area'),
    defaultHeader: I18n.t('models.tag.area'),
    accessor: 'areaName',
    allowFilter: true,
    searchable:true,
    allowSort: true,
    sortField:'areaName'
  },
  {
    Header: I18n.t('models.tag.zone'),
    defaultHeader: I18n.t('models.tag.zone'),
    accessor: 'zoneName',
    allowFilter: true,
    searchable:true,
    allowSort: true,
    sortField:'zoneName'
  },
  locationColumn,
  {
    Header: 'Last Seen', //todo: fix this broken translate, it's not loaded before these are exported.
    defaultHeader: 'Last Seen',
    accessor: 'lastSeen',
    allowFilter: false,
    searchable:false,
    allowSort: true,
    sortField:'lastEventTime',
    sorter: (item1, item2) => {
      const time1 = item1.lastEventTime ? item1.lastEventTime.getTime() : 0;
      const time2 = item2.lastEventTime ? item2.lastEventTime.getTime() : 0;
      return time1 - time2;
    }
  },
  {
    Header: I18n.t('models.tag.category'),
    defaultHeader: I18n.t('models.tag.category'),
    customLabelKey: 'category',
    accessor: 'categoryName',
    allowFilter: true,
    searchable:true,
    allowSort: true,
    sortField:'categoryName'
  },
  {
    Header: I18n.t('models.tag.group'),
    defaultHeader: I18n.t('models.tag.group'),
    customLabelKey: 'group',
    accessor: 'groupName',
    allowFilter: true,
    searchable:true,
    allowSort: true,
    sortField:'groupName'
  },
  {
    Header: I18n.t('models.tag.field1'),
    defaultHeader: I18n.t('models.tag.field1'),
    customLabelKey: 'field1',
    accessor: 'field1',
    allowFilter: true,
    searchable:true,
    allowSort: true,
    sortField:'field1'
  },
  {
    Header: I18n.t('models.tag.field2'),
    defaultHeader: I18n.t('models.tag.field2'),
    customLabelKey: 'field2',
    accessor: 'field2',
    allowFilter: true,
    searchable:true,
    allowSort: true,
    sortField:'field2'
  },
  {
    Header: 'Battery',
    defaultHeader: 'Battery',
    accessor: 'battery',
    allowFilter: true,
    searchable:true,
    allowSort: true,
    sortField:'batteryStatus'
  },
  {
    accessor: item=> item.macAddress.split(':').join(''),
    allowFilter: true,
    searchable:true,
    hidden: true
  },{
    accessor: 'macAddress',
    allowFilter: true,
    searchable:true,
    hidden: true
  },
];

export const listViewColumns = [
  {
    Header: I18n.t('models.tag.tag'),
    defaultHeader: I18n.t('models.tag.tag'),
    customLabelKey: 'tag',
    accessor: 'name',
    allowFilter: false,
    searchable:false,
    allowSort: true,
    sortField:'name'
  },
  {
    Header: I18n.t('models.tag.area'),
    defaultHeader: I18n.t('models.tag.area'),
    accessor: 'areaName',
    allowFilter: true,
    searchable:true,
    hasCustomFilterValues: true,
    customFilterValues: [],
    allowSort: true,
    sortField:'areaName'
  },
  {
    Header: I18n.t('models.tag.zone'),
    defaultHeader: I18n.t('models.tag.zone'),
    accessor: 'zoneName',
    allowFilter: true,
    searchable:true,
    hasCustomFilterValues: true,
    customFilterValues: [],
    allowSort: true,
    sortField:'zoneName'
  },
  {
    ...locationColumn,
    hasCustomFilterValues: true,
    customFilterValues: []
  },
  {
    Header: 'Last Seen', //todo: fix this broken translate, it's not loaded before these are exported.
    defaultHeader: 'Last Seen',
    accessor: 'lastSeen',
    allowFilter: false,
    searchable:false,
    allowSort: true,
    sortField:'lastEventTime',
    sorter: (item1, item2) => {
      const time1 = item1.lastEventTime ? item1.lastEventTime.getTime() : 0;
      const time2 = item2.lastEventTime ? item2.lastEventTime.getTime() : 0;
      return time1 - time2;
    }
  },
  {
    Header: I18n.t('models.tag.category'),
    defaultHeader: I18n.t('models.tag.category'),
    customLabelKey: 'category',
    accessor: 'categoryName',
    allowFilter: true,
    searchable:true,
    hasCustomFilterValues: true,
    customFilterValues: [],
    allowSort: true,
    sortField:'categoryName'
  },
  {
    Header: I18n.t('models.tag.group'),
    defaultHeader: I18n.t('models.tag.group'),
    customLabelKey: 'group',
    accessor: 'groupName',
    allowFilter: true,
    searchable:true,
    hasCustomFilterValues: true,
    customFilterValues: [],
    allowSort: true,
    sortField:'groupName'
  },
  {
    Header: I18n.t('models.tag.field1'),
    defaultHeader: I18n.t('models.tag.field1'),
    customLabelKey: 'field1',
    accessor: 'field1',
    allowFilter: true,
    searchable:true,
    hasCustomFilterValues: true,
    customFilterValues: [],
    allowSort: true,
    sortField:'field1'
  },
  {
    Header: I18n.t('models.tag.field2'),
    defaultHeader: I18n.t('models.tag.field2'),
    customLabelKey: 'field2',
    accessor: 'field2',
    allowFilter: true,
    searchable:true,
    hasCustomFilterValues: true,
    customFilterValues: [],
    allowSort: true,
    sortField:'field2'
  },
  {
    Header: 'Battery',
    defaultHeader: 'Battery',
    accessor: 'battery',
    allowFilter: true,
    searchable:true,
    hasCustomFilterValues: true,
    customFilterValues: ["Good", "Low/Empty"],
    allowSort: true,
    sortField:'batteryStatus'
  },
  {
    accessor: item=> item.macAddress.split(':').join(''),
    allowFilter: true,
    searchable:false,
    hidden: true
  },{
    accessor: 'macAddress',
    allowFilter: true,
    searchable:false,
    hidden: true
  }
];

export const FILTER_TYPE = {
  SEARCH: 'search',
  COLUMN: 'column'
};

export const POSITION_SOURCE = {
  GPS: 'gps',
  CELL_ID: 'cellid',
  WIFI: 'wifi'
};



// WEBPACK FOOTER //
// ./src/constants/data.js